import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'en-GB',
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
  weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  weekdaysMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY, HH:mm',
    'LLL-Y': 'D MMMM, HH:mm',
    LLLL: 'dddd, D MMMM YYYY, HH:mm',
    'LLLL-Y': 'dddd D MMMM, HH:mm',
    l: 'DD/MM/YYYY',
    'l-Y': 'DD/MM',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY, h:mm A',
    'lll-Y': 'D MMM, h:mm A',
    llll: 'ddd, D MMM YYYY, h:mm A',
    'llll-Y': 'ddd, D MMM, h:mm A',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY, HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'am', PM: 'pm' },
  past: {
    y: { one: '%s yr ago', other: '%s yr ago' },
    M: { one: '%s mo ago', other: '%s mo ago' },
    w: { one: '%s wk ago', other: '%s wk ago' },
    d: { one: '%s day ago', other: '%s days ago' },
    h: { one: '%s hr ago', other: '%s hr ago' },
    m: { one: '%s min ago', other: '%s min ago' },
    s: { one: '%s sec ago', other: '%s sec ago' },
  },
  future: {
    y: { one: 'in %s yr', other: 'in %s yr' },
    M: { one: 'in %s mo', other: 'in %s mo' },
    w: { one: 'in %s wk', other: 'in %s wk' },
    d: { one: 'in %s day', other: 'in %s days' },
    h: { one: 'in %s hr', other: 'in %s hr' },
    m: { one: 'in %s min', other: 'in %s min' },
    s: { one: 'in %s sec', other: 'in %s sec' },
  },
  abbr: {
    y: { one: '%s yr', other: '%s yrs' },
    M: { one: '%s mth', other: '%s mths' },
    w: { one: '%s wk', other: '%s wks' },
    d: { one: '%s day', other: '%s days' },
    h: { one: '%s hr', other: '%s hrs' },
    m: { one: '%s min', other: '%s mins' },
    s: { one: '%s sec', other: '%s secs' },
  },
  justNow: 'now',
  yesterday: 'yesterday',
  today: 'today',
  tomorrow: 'tomorrow',
  weekStart: 1,
};
const localeName: LocaleName = 'en-GB';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'am';
    } else {
      return isLowerCase ? 'pm' : 'pm';
    }
  },
};
